class ContentReveal {
  constructor(revealClass = "show") {
    this.revealClass = revealClass

    // Get all triggers
    const triggers = document.querySelectorAll("[data-content-reveal-trigger]")

    // For each trigger attach click event to show content on click
    if (triggers.length) {
      for (let i = 0; i < triggers.length; i++) {
        triggers[i].addEventListener("click", e => {
          e.preventDefault()
          this.revealContent(triggers[i])
        })
      }
    }
  }

  revealContent(trigger) {
    // Get value of data attribute from the trigger
    const contentSelector = trigger.getAttribute("data-content-reveal-trigger")
    // Select all content and add show css class to to the content to be revealed
    const content = document.querySelectorAll(contentSelector)
    if (content.length) {
      // Indicate that the trigger is clicked
      trigger.setAttribute("data-content-reveal-triggered", "true")

      // Get element to set focus to after elements are revealed
      const focusElement = this.getFocusElement(trigger, content)

      for (let i = 0; i < content.length; i++) {
        // Remove boostrap hidden utility class then add reveal class
        content[i].classList.remove("d-none")
        content[i].classList.add(this.revealClass)
      }

      // Focus element
      if (focusElement) {
        focusElement.focus()
      }
    }
  }

  getFocusElement(trigger, content) {
    // Element selector defined in trigger where focus need to be set
    const selector = trigger.getAttribute("data-content-reveal-focus")

    // Return element based on selector defined in trigger
    if (selector) {
      const element = document.querySelector(selector)
      if (element) {
        return element
      }
    }

    // Get instance of first element to be revealed and set focus to
    if (typeof content[0] !== "undefined") {
      return content[0]
    }

    return null
  }
}

export default ContentReveal
